<form #thisForm="ngForm" [ngClass]="{ 'card mt-3': showHeader === true }">
  <div class="card mt-3" *ngIf="!isCetipQuota">
    <div class="card-header text-uppercase">Dados da Contraparte</div>
    <div class="card-body">
      <div class="row mb-2">
        <div class="col-3">
          <div>
            <div class="form-check form-check-inline">
              <label for="isNewCounterpart">Nova Contraparte</label>
              <input
                data-cy="isNewCounterpart"
                class="form-check-input"
                id="isNewCounterpart"
                name="isNewCounterpart"
                [(ngModel)]="counterpartModel.isNewCounterpart"
                [checked]="counterpartModel.isNewCounterpart"
                type="checkbox"
              />
            </div>
          </div>
        </div>
        <div class="col-4" *ngIf="counterpartModel.isNewCounterpart">
          <label for="counterpartType"> Documento</label>
          <div>
            <div class="form-check form-check-inline">
              <input
                class="form-check-input"
                data-cy="counterpartTypeCPF"
                id="cpf"
                name="counterpartType"
                type="radio"
                [value]="1"
                [(ngModel)]="counterpartModel.type"
              />
              <label class="form-check-label" for="cpf">Pessoa Física</label>
            </div>
            <div class="form-check form-check-inline">
              <input
                class="form-check-input"
                data-cy="counterpartType"
                id="cnpj"
                name="counterpartType"
                type="radio"
                [value]="2"
                [(ngModel)]="counterpartModel.type"
              />
              <label class="form-check-label" for="cnpj">Pessoa Jurídica</label>
            </div>
          </div>
        </div>
      </div>
      <div class="row mb-2" *ngIf="!counterpartModel.isNewCounterpart">
        <div class="col-4" [class.has-error]="hasError('name')">
          <label>Nome</label>
          <ng-select
            notFoundText="Contraparte não encontrada"
            typeToSearchText="Digite o nome da contraparte para pesquisar..."
            [selectOnTab]="true"
            [required]="isNoFinancialQuota"
            (change)="fillComponentWhenCounterpartSelected()"
            [(ngModel)]="selectedCounterpart"
            [ngModelOptions]="{ standalone: true }"
            [typeahead]="counterpartSearchNameTerm"
            [items]="counterpartByName | async"
            [clearable]="false"
            bindLabel="name"
            [disabled]="!formEnabled"
          >
            <ng-template ng-label-tmp let-item="item">
              {{ item.name }}
            </ng-template>
            <ng-template ng-option-tmp let-item="item">
              {{ item.document }} {{ item.name }}
            </ng-template>
          </ng-select>
        </div>

        <div class="col-4" [class.has-error]="hasError('document')">
          <label>CPF/CNPJ</label>
          <ng-select
            notFoundText="Contraparte não encontrada"
            typeToSearchText="Digite o CNPJ da contraparte para pesquisar..."
            [selectOnTab]="true"
            (change)="fillComponentWhenCounterpartSelected()"
            [(ngModel)]="selectedCounterpart"
            [ngModelOptions]="{ standalone: true }"
            [typeahead]="counterpartSearchDocumentTerm"
            [items]="counterpartByDocument | async"
            [clearable]="false"
            bindLabel="document"
            [disabled]="!formEnabled"
          >
            <ng-template ng-label-tmp let-item="item">
              {{ item.document }}
            </ng-template>
            <ng-template ng-option-tmp let-item="item">
              {{ item.document }} {{ item.name }}
            </ng-template>
          </ng-select>
        </div>

        <div
          class="col-4"
          [class.has-error]="hasError('bank')"
          *ngIf="
            (isCetip() && !isNoFinancialCETIP) ||
            (isQuota() && !isNoFinancialQuota) ||
            isMoneyMargin
          "
        >
          <label>Dados Bancários</label>
          <ng-select
            [(ngModel)]="selectedCounterpartAccount"
            [ngModelOptions]="{ standalone: true }"
            [items]="counterpartAccountList"
            [clearable]="false"
            [disabled]="!formEnabled"
          >
            <ng-template
              ng-label-tmp
              let-item="item"
              *ngIf="selectedCounterpartAccount !== null"
            >
              Banco: {{ item.bank }}&nbsp;&nbsp;&nbsp;&nbsp;Agência:
              {{ item.branch }}&nbsp;&nbsp;&nbsp;&nbsp;Conta Corrente:
              {{ item.account }}
            </ng-template>
            <ng-template ng-header-tmp *ngIf="counterpartAccountList !== null">
              <div class="row mb-2">
                <div class="col-4">Banco</div>
                <div class="col-4">Agência</div>
                <div class="col-4">Conta</div>
              </div>
            </ng-template>
            <ng-template ng-option-tmp let-item="item">
              Banco: {{ item.bank }}&nbsp;&nbsp;&nbsp;&nbsp;Agência:
              {{ item.branch }}&nbsp;&nbsp;&nbsp;&nbsp;Conta Corrente:
              {{ item.account }}
            </ng-template>
          </ng-select>
        </div>
        <div class="col-4">
          <label *ngIf="isSelic() || isContracted()">Conta SELIC</label>
          <input
            type="text"
            *ngIf="isSelic() || isContracted()"
            class="form-control"
            name="selicAccount"
            data-cy="selicAccount"
            [(ngModel)]="counterpartModel.selicAccount"
            pattern="\d+-?\d*"
            maxlength="10"
            value=""
          />
          <label
            *ngIf="
              (isMargin() && isRFPrivateMargin) ||
              isCurrencyTerm() ||
              isSwapCetip()
            "
            >Conta Cetip</label
          >
          <input
            type="text"
            *ngIf="
              (isMargin() && isRFPrivateMargin) ||
              isCurrencyTerm() ||
              isSwapCetip()
            "
            class="form-control"
            name="cetipAccount"
            data-cy="cetipAccount"
            [(ngModel)]="counterpartModel.clearingAccount"
            pattern="\d+-?\d*"
            maxlength="10"
            value=""
          />
          <label *ngIf="isMargin() && isRFPublicMargin"
            >Conta Garantia Selic</label
          >
          <input
            type="text"
            *ngIf="isMargin() && isRFPublicMargin"
            class="form-control"
            name="warrantySelicAccount"
            data-cy="warrantySelicAccount"
            [(ngModel)]="counterpartModel.clearingAccount"
            pattern="\d+-?\d*"
            maxlength="10"
            value=""
          />
          <label *ngIf="isMargin() && isVariableIncomeMargin">Conta B3</label>
          <input
            type="text"
            *ngIf="isMargin() && isVariableIncomeMargin"
            class="form-control"
            name="B3Account"
            data-cy="B3Account"
            [(ngModel)]="counterpartModel.clearingAccount"
            pattern="\d+-?\d*"
            maxlength="10"
            value=""
          />
        </div>
        <div class="col-4">
          <label *ngIf="isMargin() && isVariableIncomeMargin"
            >Conta Broker</label
          >
          <input
            type="text"
            *ngIf="isMargin() && isVariableIncomeMargin"
            class="form-control"
            name="brokerAccount"
            data-cy="brokerAccount"
            [(ngModel)]="counterpartModel.brokerAccount"
            pattern="\d+-?\d*"
            maxlength="10"
            value=""
          />
        </div>
      </div>

      <div *ngIf="counterpartModel.isNewCounterpart" class="row mb-2">
        <div class="col-6" [class.has-error]="hasError('name')">
          <label>Nome</label>
          <input
            data-cy="counterpartName"
            type="text"
            class="form-control"
            name="counterpartName"
            [(ngModel)]="counterpartModel.name"
            maxlength="90"
            pattern="^(?!\s*$).+"
            required
          />
        </div>

        <div class="col-6">
          <label *ngIf="isSelic() || isContracted()">Conta SELIC</label>
          <input
            type="text"
            *ngIf="isSelic() || isContracted()"
            class="form-control"
            name="counterpartSelicAccount"
            data-cy="counterpartSelicAccount"
            [(ngModel)]="counterpartModel.selicAccount"
            pattern="\d+-?\d*"
            maxlength="10"
            value=""
          />

          <label *ngIf="isRFPrivateMargin || isCurrencyTerm() || isSwapCetip()"
            >Conta Cetip</label
          >
          <input
            type="text"
            *ngIf="isRFPrivateMargin || isCurrencyTerm() || isSwapCetip()"
            class="form-control"
            name="counterpartCetipAccount"
            data-cy="counterpartCetipAccount"
            [(ngModel)]="counterpartModel.clearingAccount"
            pattern="\d+-?\d*"
            maxlength="10"
            value=""
          />

          <label *ngIf="isRFPublicMargin">Conta Garantia Selic</label>
          <input
            type="text"
            *ngIf="isRFPublicMargin"
            class="form-control"
            name="warrantySelicAccount"
            data-cy="warrantySelicAccount"
            [(ngModel)]="counterpartModel.clearingAccount"
            pattern="\d+-?\d*"
            maxlength="10"
            value=""
          />

          <label *ngIf="isVariableIncomeMargin">Conta B3</label>
          <input
            type="text"
            *ngIf="isVariableIncomeMargin"
            class="form-control"
            name="B3Account"
            data-cy="B3Account"
            [(ngModel)]="counterpartModel.clearingAccount"
            pattern="\d+-?\d*"
            maxlength="10"
            value=""
          />
        </div>

        <div class="col-6" [class.has-error]="hasError('document')">
          <label *ngIf="counterpartModel.type === 1">CPF</label>
          <input
            type="text"
            *ngIf="counterpartModel.type === 1"
            class="form-control"
            name="document"
            data-cy="document"
            [(ngModel)]="counterpartModel.document"
            mask="000.000.000-00"
            required
          />
          <label *ngIf="counterpartModel.type === 2">CNPJ</label>
          <input
            type="text"
            *ngIf="counterpartModel.type === 2"
            class="form-control"
            name="document"
            data-cy="document"
            [(ngModel)]="counterpartModel.document"
            mask="00.000.000/0000-00"
            required
          />
        </div>

        <div class="col-6" *ngIf="isVariableIncomeMargin">
          <label>Conta Broker</label>
          <input
            data-cy="brokerAccount"
            type="text"
            class="form-control"
            name="brokerAccount"
            [(ngModel)]="counterpartModel.brokerAccount"
            maxlength="90"
            pattern="^(?!\s*$).+"
          />
        </div>
      </div>

      <div
        *ngIf="
          (counterpartModel.isNewCounterpart &&
            isCetip() &&
            !isNoFinancialCETIP) ||
          (counterpartModel.isNewCounterpart && isMoneyMargin) ||
          (counterpartModel.isNewCounterpart &&
            isQuota() &&
            !isNoFinancialQuota)
        "
        class="row mb-2"
      >
        <div class="col-4" [class.has-error]="hasError('bank')">
          <label>Banco</label>
          <app-select-bank
            #bankComponent
            name="fundBank"
            [banks]="banksList"
            [(selectedBankId)]="selectedCounterpartAccount.bank"
            [readOnly]="!edit()"
          ></app-select-bank>
        </div>
        <div class="col-3" [class.has-error]="hasError('branch')">
          <label>Agência (Sem Dígito)</label>
          <input
            data-cy="fundBranch"
            type="text"
            class="form-control"
            name="fundBranch"
            [(ngModel)]="selectedCounterpartAccount.branch"
            pattern="\w+-?\w*"
            maxlength="4"
            mask="0000"
          />
        </div>
        <div class="col-5" [class.has-error]="hasError('account')">
          <label>Conta</label>
          <input
            data-cy="fundAccount"
            type="text"
            class="form-control"
            name="fundAccount"
            [(ngModel)]="selectedCounterpartAccount.account"
            pattern="\w+-?\w*"
            maxlength="15"
          />
        </div>
      </div>
    </div>
  </div>
</form>
